// Library Imports
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Search } from '@mui/icons-material';
import { Box, InputAdornment, TextField, Typography } from '@mui/material';

// Local Imports
import axios from '@/redux/http';
import endPoints from '@/redux/constant';
import { Loader } from '@/components/Shared/Loader';
import { customToast } from '@/utils';

export const StatesDropDown = ({ countryName, onStateClick }) => {
  // Redux States
  const userId = useSelector(state => state?.currentUser?.currentUser?.userId);
  const countries = useSelector(state => state?.countriesAndStates?.countries);

  // States
  const [selectedCountryStates, setSelectedCountryStates] = useState([]);
  const [filteredStates, setFilteredStates] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const getSelectedCountryStates = async () => {
    const name = countries?.find(
      country => country?.name === countryName
    )?.name;

    try {
      axios
        .get(`${endPoints.fetchStates}?country=${name}`)
        .then(res => {
          const data = res?.data?.result?.data?.states?.map((state, index) => ({
            id: index + 1,
            stateCode: state?.state_code,
            name: state?.name
          }));
          setSelectedCountryStates(data || []);
          setFilteredStates(data || []);
          setIsLoading(false);
        })
        .catch(err => {
          setIsLoading(false);
          customToast.error(err?.response?.data?.message);
        });
    } catch (err) {
      console.log(err);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setIsLoading(true);
    getSelectedCountryStates();
  }, [userId]);

  useEffect(() => {
    if (searchTerm === '') {
      setFilteredStates(selectedCountryStates);
    } else {
      const filtered = selectedCountryStates?.filter(country =>
        country?.name?.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredStates(filtered);
    }
  }, [searchTerm, selectedCountryStates]);

  return (
    <Box
      component={'div'}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        // border: { xs: '1px solid gray', md: '1px solid' },
        // borderRadius: '4px',
        maxHeight: '270px',
        // width: { sm: '480px' },
        overflow: 'auto',
        '&::-webkit-scrollbar': {
          width: '5px',
          height: '5px'
        },
        '&::-webkit-scrollbar-track': {
          background: '#f1f1f1'
        },
        '&::-webkit-scrollbar-thumb': {
          background: '#d2d2d2',
          borderRadius: '4px'
        }
      }}
      onClick={e => {
        e.stopPropagation();
        // e.preventDefault();
      }}
    >
      {isLoading ? (
        <div className='min-w-[280px] md:w-full h-[280px] horizontal-center'>
          <Loader />
        </div>
      ) : (
        <>
          <Box
            sx={{
              // backgroundColor: '#f2f2f2',
              p: '0.56rem',
              top: 0,
              position: 'sticky'
            }}
          >
            <TextField
              sx={{
                bgcolor: 'white',
                borderColor: theme => theme.palette.grey['50'],
                outline: 'none',
                borderRadius: '8px',
                boxShadow: '0 0 6px 0 rgba(0, 0, 0, 0.08)',
                width: '100%'
              }}
              variant='outlined'
              placeholder={'Search Cities'}
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
              // onClick={(e) => e.stopPropagation()}
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>
                    <Search />
                  </InputAdornment>
                )
              }}
            />
          </Box>

          {filteredStates?.length === 0 ? (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
                px: '1.5rem',
                py: '2rem'
              }}
            >
              <Typography
                sx={{
                  fontSize: '1rem',
                  color: 'grey'
                }}
              >
                Please add a valid City
              </Typography>
            </Box>
          ) : (
            <Box
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '1rem',
                px: '1rem',
                pt: '10px',
                mr: '0.5rem',
                overflow: 'auto'
              }}
            >
              {filteredStates?.map((state, index) => (
                <Box
                  key={index}
                  sx={{
                    width: { xxs: '100%', sm: '48%' },
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    mb: '1.25rem'
                  }}
                  onClick={() => onStateClick(state)}
                >
                  <Typography
                    sx={{
                      fontSize: '1rem',
                      lineHeight: '1.6rem',
                      pl: '0.75rem'
                    }}
                  >
                    {state?.name}
                  </Typography>
                </Box>
              ))}
            </Box>
          )}
        </>
      )}
    </Box>
  );
};
